window.searchDelay = 0;

function search() {
    clearTimeout(searchDelay);
    const searchTerm = String($('#search').val() ?? '').trim();

    if (!searchTerm || searchTerm.length < 3) {
        $('#search_loader').addClass('d-none');
        $('#search_holder').empty();

        return false;
    }

    $('#search_loader').removeClass('d-none');

    searchDelay = setTimeout(function () {
        $.ajax({
            method: 'GET',
            url: '/blog/search/json',
            dataType: 'json',
            data: {
                search: searchTerm,
            },
            success: function (response) {
                $('#search_loader').addClass('d-none');
                let html = '';

                switch (response.status) {
                    case 'ERROR':
                        html += '<p class="text-muted">'+__('Er zijn geen artikelen gevonden.')+'</p>';
                        break;
                    case 'OK':
                        html += '<div class="list-group search-results-dropdown">';
                        $.each(response.data, function (key, value) {
                            const bg = (parseInt(key, 10) % 2 === 0) ? 'list-group-item-light' : '';
                            html += '<div class="list-group-item '+bg+'">';
                            html += '<a href="'+value.href+'">'+value.title+'</a>';
                            html += '</div>';
                        });
                        html += '</div>';
                        break;
                }

                $('#search_holder').html(html);
            },
            error: function () {
                $('#search_loader').addClass('d-none');
                $('#search_holder').html('<p class="text-muted">'+__('Er is een fout opgetreden.')+'</p>');
            },
        });
    }, 500);
}

$(function () {
    $(document).on('input keyup', '#search', function (e) {
        e.preventDefault();
        search();
    });
});
